import React from 'react';
import { Typography } from '@metarouter-private/mr-mui';

export default function FileRequirements() {
  return (
    <Typography variant="body2" color="text.secondary">
      We detect the file type from its contents — you can change it below if needed. The file must contain valid
      configuration.
    </Typography>
  );
}
